import { useRouter } from 'next/router'
import { mainNavData } from './footer-data'
import type { LinkData } from './footer-data'
import Link from '@/components/Common/Link'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import { EN_ALL_FOOTER_LINKS } from '@/root/utils/common/web/gtm-events/eventsList'

export default function MainNav1() {
  const pushEvent = useAnalyticsEvent()

  const { asPath } = useRouter()
  return (
    <nav className="mb-8 flex justify-between space-x-4 md:space-x-0 lg:mb-auto lg:max-w-2xl">
      {mainNavData.map(item => {
        return (
          <div key={item.heading}>
            <div className="text-brand-white mb-3 text-sm font-medium lg:text-xl">
              {item.heading}
            </div>

            <ul className="space-y-2">
              {item.listItems.map(listItem => {
                const link = listItem.link

                const { rel, target } = listItem

                const conditionalProps: Pick<LinkData, 'rel' | 'target'> = {}

                if (rel) {
                  conditionalProps.rel = rel
                }

                if (target) {
                  conditionalProps.target = target
                }
                return (
                  <li
                    className="w-full text-sm font-normal lg:text-base"
                    key={listItem.title}
                  >
                    <Link
                      className="block w-full py-1"
                      href={link}
                      {...conditionalProps}
                      absoluteUrlScheme
                      onClick={() => {
                        pushEvent({
                          gtmPayload: {
                            eventName: EN_ALL_FOOTER_LINKS,
                            source: asPath,
                            lob: link,
                            allPageParams: {
                              footer_click_text: listItem.title,
                            },
                          },
                        })
                      }}
                      title={listItem.title}
                    >
                      {listItem.title}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </nav>
  )
}
